import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { IOrderItem } from '../../../providers';

import { OptionsMore } from './OptionsMore';
import { OrderOption } from './OrderOption';

import styles from './styles.module.scss';

export const Options = memo<{ options: IOrderItem['options']; otherOptionsCount?: null | number }>((props) => {
  const { t } = useTranslation('orders');

  return (
    <>
      {props.options?.map((option) => (
        <OrderOption
          key={option.name}
          name={option.name}
          value={option.value}
          factor={option.factor}
          totalPrice={option.totalPrice}
        />
      ))}

      {!!props.otherOptionsCount && (
        <div className={cn('mt-2', styles.optionsMore)}>+ ещё {t('options', { count: props.otherOptionsCount })}</div>
      )}
    </>
  );
});
